function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0007 4.66634V2.66634C12.0007 1.93301 11.4007 1.33301 10.6673 1.33301H5.33398C4.60065 1.33301 4.00065 1.93301 4.00065 2.66634V4.66634H3.33398V8.66634L5.33398 12.6663V14.6663H10.6673V12.6663L12.6673 8.66634V4.66634H12.0007ZM5.33399 2.66633H10.6673V4.66633H9.32732V3.33299H8.66065V4.66633H7.33399V3.33299H6.66732V4.66633H5.33399V2.66633ZM9.33393 12.353L11.3339 8.35302V5.99969H4.66726V8.35302L6.66726 12.353V13.333H9.33393V12.353Z"
});

var SvgDevices = function SvgDevices(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDevices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/devices.52c77f56.svg";
export { ForwardRef as ReactComponent };